import React from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

type ButtonType = 'button' | 'submit' | 'reset';

interface Props {
  text: React.ReactNode;
  onClick?: () => void;
  inverted?: boolean;
  type?: ButtonType;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  form?: string;
}
export function Button({ text, inverted, loading, ...props }: Props) {
  return (
    <button
      {...props}
      className={classNames(
        styles.button,
        props.className,
        inverted && styles.inverted,
        props.disabled && styles.disabled,
        loading && styles.loading,
      )}
      disabled={props.disabled}
    >
      {text}
    </button>
  );
}

Button.defaultProps = {
  type: 'button',
  inverted: false,
  onClick: () => {},
};
